export default __webpack_public_path__ + "static/media/kaminfeuer_web-xs@2x.6e12af59.jpg";